export const FPG_PLANS = {
  standard: 'standard',
  advanced: 'advanced',
};

export const LAST_UPDATE = '2025-09-01'